import { defineStore } from "pinia";
const useProductDataStore = defineStore("productDataStore", {
  state: () => ({
    product: {
      allDisplayableSkusAreBackorder: false,
      allDisplayableSkusArePreorder: false,
      allSkusAreBopusOnly: false,
      allSkusAreMembersOnly: false,
      anyOversizeCharges: false,
      anySkuShippingRestrictions: false,
      anySkusAreMembersOnly: false,
      availablePrices: [],
      badges: [],
      brand: null,
      breadcrumbs: [],
      byColor: {},
      bySize: {},
      bySku: {},
      canonicalUrl: "",
      colors: [],
      computedPricePermutations: {
        colors: 0,
        sizes: 0
      },
      description: "",
      displayOptions: {
        carouselOrientation: "horizontal",
        colorLabel: "",
        dividendEstimatedSavingsPercentageText: "",
        dividendEstimatedSavingsText: "",
        estimatedReward: null,
        featuredImage: {
          altText: "",
          baseUri: "",
          caption: "",
          color: {
            name: "",
            code: "",
            colorFamily: "",
            displayLabel: "",
            hexValue: []
          },
          featured: true,
          heroImageUri: "",
          maxHeight: 0,
          maxWidth: 0,
          thumbnailUri: "",
          type: "",
          uri: ""
        },
        pupInfo: { isPup: false },
        showAllDetailImages: true,
        showDividendMessage: true,
        showSkuDropDown: false,
        showSwatches: true,
        showTermsAndConditions: false,
        sizeLabel: ""
      },
      eligibleForShipping: true,
      featuredSpecs: [],
      features: [],
      flairBadges: [],
      hideOversizeMessaging: false,
      images: [],
      membershipV2: null,
      mixedPriceOptions: {
        isMixedPrice: false,
        isPriceByColor: false,
        isPriceBySize: false,
        isPriceBySizeAndColor: false
      },
      optionsAvailableByPrice: {},
      optionsAvailableWithoutPrice: {
        colors: {},
        sizes: {}
      },
      outlet: false,
      originCountry: "",
      oversizeCharges: [],
      priceByColor: {},
      primaryCategory: null,
      productLineUrl: null,
      productLineUrlLabel: null,
      relatedLinks: [],
      relatedProducts: [],
      reviewSummary: {
        count: 0,
        averageRating: 0,
        ratingHistogram: {
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0
        },
        topRated: false
      },
      sellingCopy: null,
      showSwatches: true,
      showExpandedReturnMessaging: false,
      showExpertAdviceContent: false,
      sizeChart: null,
      sizes: [],
      skus: [],
      skusForOption: {
        colors: {},
        sizes: {}
      },
      styleId: "",
      stylePrice: {
        maxCompareAt: {
          sale: false,
          saleOnly: false,
          offerType: null,
          value: 0,
          compValue: 0,
          clearance: false
        },
        maxPrice: {
          sale: false,
          saleOnly: false,
          offerType: null,
          value: 0,
          compValue: 0,
          clearance: false
        },
        minCompareAt: {
          sale: false,
          saleOnly: false,
          offerType: null,
          value: 0,
          compValue: 0,
          clearance: false
        },
        minPrice: {
          sale: false,
          saleOnly: false,
          offerType: null,
          value: 0,
          compValue: 0,
          clearance: false
        },
        map: false,
        minSavingsDollarAmount: null,
        maxSavingsDollarAmount: null,
        minSavingsPercentage: null,
        maxSavingsPercentage: null,
        offerType: null
      },
      summaryV2: {
        productId: 0,
        totalReviewCount: 0,
        averageOverallRating: 0,
        fiveStarRatingCount: 0,
        fourStarRatingCount: 0,
        threeStarRatingCount: 0,
        twoStarRatingCount: 0,
        oneStarRatingCount: 0,
        batchUpdateId: 0,
        topRated: false,
        recommended: 0,
        notRecommended: 0,
        ratingsOnlyReviewCount: 0,
        secondaryReviewsAvg: [],
        recommendedPercentage: 0,
        ratingCounts: [
          { rating: 5, count: 0, percentage: 0 },
          { rating: 4, count: 0, percentage: 0 },
          { rating: 3, count: 0, percentage: 0 },
          { rating: 2, count: 0, percentage: 0 },
          { rating: 1, count: 0, percentage: 0 }
        ],
        reviewsWithPhotos: []
      },
      reviewPage: {
        content: void 0,
        totalElements: 0,
        totalPages: 0,
        offsetSize: 0,
        minimumElementOnPage: 0
      },
      taxCat: {
        name: "",
        canonical: ""
      },
      taxCatRoot: [],
      techSpecs: [],
      title: "",
      userManuals: [],
      videos: []
    }
  }),
  getters: {
    availableColors(state) {
      return state.product.colors.filter((color) => {
        var _a, _b;
        return ((_b = (_a = state.product.byColor[color.code]) == null ? void 0 : _a.available) == null ? void 0 : _b.length) > 0;
      });
    },
    sellableStatuses() {
      return ["AVAILABLE", "PRE_ORDER", "BACKORDER"];
    },
    sellableSkus(state) {
      return state.product.skus.filter((sku) => this.sellableStatuses.includes(sku.status));
    }
  }
});
export {
  useProductDataStore as default
};
//# sourceMappingURL=productDataStore.mjs.map
